/**
 * PageSpeed: ленивая загрузка CSS + Vue; блокировка ATC до mount.
 * Копируется в theme/assets при npm run build:dynamic-options.
 *
 * Sync gate (inline) в snippets/dynamic-options.liquid лочит кнопки до этого файла.
 */
(function () {
  const ATC_SELECTOR =
    '[data-add-to-cart], button[name="add"], [data-cart-bar-add-to-cart]'
  const PAYMENT_SELECTOR = '.shopify-payment-button'

  const root =
    document.getElementById('dynamic-options-root') ||
    document.getElementById('dynamic-options')
  if (!root) return

  const scriptUrl = root.dataset.scriptUrl
  const cssUrl = root.dataset.cssUrl
  if (!scriptUrl) return

  let loadPromise = null
  let observer = null

  function getProductInfo() {
    return root.closest('product-info')
  }

  // Root starts [hidden] (display:none) so IO never fires on it — observe the product section.
  function getObserveTarget() {
    return getProductInfo() || root.closest('.product__dynamic-options') || root
  }

  function applyLockStyles(el) {
    if (el.dataset.doAtcLocked === 'true') return
    el.dataset.doAtcLocked = 'true'
    el.style.pointerEvents = 'none'
    el.style.opacity = '0.55'
    el.style.cursor = 'not-allowed'

    if (
      el.matches &&
      el.matches('button, input') &&
      !el.hasAttribute('disabled')
    ) {
      el.setAttribute('disabled', '')
      el.dataset.doDisabled = 'true'
      el.setAttribute('aria-disabled', 'true')
    }
  }

  function lockBuyButtons() {
    const productInfo = getProductInfo()
    if (!productInfo || productInfo.dataset.doAtcReady === 'true') return

    productInfo.querySelectorAll(ATC_SELECTOR).forEach(applyLockStyles)
    productInfo.querySelectorAll(PAYMENT_SELECTOR).forEach(applyLockStyles)
  }

  function loadStylesheet(href) {
    if (!href || document.querySelector('link[data-do-stylesheet="' + href + '"]')) {
      return Promise.resolve()
    }

    return new Promise(function (resolve, reject) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = href
      link.setAttribute('data-do-stylesheet', href)
      link.onload = function () {
        resolve()
      }
      link.onerror = reject
      document.head.appendChild(link)
    })
  }

  function ensureLoaded() {
    if (root.dataset.doReady === 'true') {
      return Promise.resolve()
    }

    if (loadPromise) return loadPromise

    root.classList.add('is-loading')

    loadPromise = loadStylesheet(cssUrl)
      .then(function () {
        return import(scriptUrl)
      })
      .then(function (mod) {
        const mount =
          mod.mountDynamicOptions || globalThis.__dynamicOptionsMount
        if (typeof mount === 'function') {
          mount()
        }
      })
      .catch(function (err) {
        root.classList.remove('is-loading')
        loadPromise = null
        console.error('[dynamic-options] Failed to load', err)
        // Keep ATC locked — do not unlock on failure.
        var statusEl = document.querySelector('[data-do-status]')
        if (statusEl) statusEl.value = 'error'
        throw err
      })

    return loadPromise
  }

  function startObserver() {
    if (!('IntersectionObserver' in window)) {
      ensureLoaded()
      return
    }

    observer = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (entry) {
            return entry.isIntersecting
          })
        ) {
          return
        }

        observer.disconnect()
        observer = null
        ensureLoaded()
      },
      { rootMargin: '320px 0px' },
    )

    observer.observe(getObserveTarget())
  }

  document.addEventListener('dynamic-options:request-load', function () {
    if (observer) {
      observer.disconnect()
      observer = null
    }
    ensureLoaded()
  })

  function syncAfterVariantChange() {
    const productInfo = getProductInfo()
    if (!productInfo) return

    if (productInfo.dataset.doAtcReady === 'true') {
      productInfo.querySelectorAll('[data-do-disabled="true"]').forEach(function (el) {
        el.removeAttribute('disabled')
        el.removeAttribute('data-do-disabled')
        el.removeAttribute('aria-disabled')
        el.removeAttribute('data-do-atc-locked')
        el.style.pointerEvents = ''
        el.style.opacity = ''
        el.style.cursor = ''
      })
      return
    }

    lockBuyButtons()
  }

  lockBuyButtons()
  document.addEventListener('DOMContentLoaded', lockBuyButtons, { once: true })
  document.addEventListener('variant-change', syncAfterVariantChange)
  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, syncAfterVariantChange)
  }

  if ('requestAnimationFrame' in window) {
    requestAnimationFrame(function () {
      requestAnimationFrame(lockBuyButtons)
    })
  }

  startObserver()
})()
